import source from '../../../../docs/MAX/src/consts/budgetRegionalLocations.json'

import { SelectionOption } from '../core/types/chat.types'

const budgetRegionalLocations = source as SelectionOption[]

export default budgetRegionalLocations
